import { Colors } from "@zapier/design-system";

type Props = {
  fill?: string;
  height?: string;
  width?: string;
};

export function ExpandIcon({ fill, height = "16", width = "16" }: Props) {
  function getFill() {
    if (fill) {
      return fill;
    }
    return Colors.GrayWarm1;
  }
  const selectedFill = getFill();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6673 1.33301L9.33398 2.66634H12.394L8.80395 6.4258L9.75062 7.37246L13.334 3.60634V6.66634L14.6673 5.33301V1.33301H10.6673Z"
        fill={selectedFill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.20373 9.78149L6.25706 8.83482L2.66732 12.393V9.33301L1.33398 10.6663V14.6663H5.33398L6.66732 13.333H3.60732L7.20373 9.78149Z"
        fill={selectedFill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
